import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';

export default data => {
  const dataModify = parseToMutationRequest(data, ['index']);
  const modifyChartOfAccount = `modifyChartOfAccount(input: ${dataModify})`;
  return gql`
  mutation {
    ${modifyChartOfAccount} {
      id
    }
  }
`;
};
